import React from 'react';
import { styled } from '@compiled/react';
import { lazy } from 'react-loosely-lazy';
import { ModalBody } from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import Placeholder from '@atlassian/jira-placeholder';
import type { VersionPickerProps as Props } from './index';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyVersionsPicker = lazy(() =>
	import(/* webpackChunkName: "async-version-picker" */ './index').then(
		(module) => module.VersionPicker,
	),
);

const LoadingModal = () => (
	<ModalBody>
		<LoadingWrapper>
			<Spinner size="large" />
		</LoadingWrapper>
	</ModalBody>
);

export const VersionPicker = (props: Props) => (
	<Placeholder name="version-picker" fallback={<LoadingModal />}>
		<LazyVersionsPicker {...props} />
	</Placeholder>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LoadingWrapper = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 20}px`,
});
